import React, {FC, ReactNode, useContext, useMemo} from 'react'
import s from './Layout.module.css'
import { svgIcons } from '../../assets/svgIcons'
import logo from '../../../public/logo.png'
import BalanceContext from '../../context/BalanceContext'
import InitialStateContext from '../../context/InitialStateContext'
import { checkCurrencyCode } from '../../utils/checkCurrencyCode'
import { Link, useSearchParams } from 'react-router-dom'
import Footer from '../Game/Footer/Footer'
import classNames from 'classnames'

const Layout: FC<IProps> = ({children}) => {
    const [initialState] = useContext(InitialStateContext)
    const [balance] = useContext(BalanceContext)

    const [params] = useSearchParams()
    const exitUrl = useMemo(() => params.get('ExitUrl'), [params])
    const partnerId = params.get('PartnerId')
    const isDrizzlePartner = useMemo(() => partnerId === process.env.REACT_APP_DRIZZLE_PARTNER_ID, [partnerId])

    const exitGame = () => {
        window.parent.postMessage({
            type: 'agg.exit',
        }, '*')
    }

    return (
        <div className={classNames(s.layout, { [s.drizzle]: isDrizzlePartner })}>
            {!!Object.keys(initialState).length && (
                <div className={s.head}>
                    {exitUrl && <a href={exitUrl} target="_parent" onClick={exitGame}>{svgIcons.arrows.left}</a>}
                    <img
                        src={isDrizzlePartner ? 'drizzle-logo.webp' : '/logo.png'}
                        alt="Wheel"
                        className={s.logo}
                    />
                    <div className={s.balance}>
                        <span>{checkCurrencyCode(initialState?.currencyCode)}</span>
                        <span>{balance.toFixed(initialState?.currencyPrecision)}</span>
                        {/*<Button onClick={() => deposit()} className={s.btn}>*/}
                        {/*    Deposit*/}
                        {/*</Button>*/}
                    </div>
                </div>
            )}

            <div className={s.content}>
            {children}
            </div>

            {!!Object.keys(initialState).length && <Footer />}
        </div>
    )
}

export default Layout

interface IProps {
    children: ReactNode
}